import React from 'react';
import {injectIntl} from "react-intl";
import BoldText from "../../common/text/BoldText";
import {connect} from "react-redux";
import RentalReportingModal from "../../carpark/delivery/RentalReportingModal";
import {Col, Row} from "antd";

class RentalVehicle extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {intervention: {journey: {rentalContract: {id: rentalContractId, rentingJourney = {}}}}} = this.props;
    this.props.dispatchFetchRentalContract(rentalContractId);
    if (rentingJourney.id) {
      this.props.dispatchFetchJourneyIdentityDocuments({uuid: rentingJourney.journeyUuid, connectedUserId: rentingJourney.customer.id})
    }
  }

  unassignMobility = () => {
    const {intervention: {id: interventionId, journey: {rentalContract: {id}}}} = this.props;
    this.props.dispatchUnassignRentalVehicle({id, interventionId});
  };

  onShowReportingModal = () => {
    this.props.showDeliveryModal();
  };

  onHideReportingModal = () => {
    this.props.hideDeliveryModal();
  };

  render() {
    const {intl: {formatMessage}, rentalVehicle, intervention, intervention: {journey}, canWrite} = this.props;
    const {fetchRentalReporting: {showModal, reporting = {}}, fetchRentalContract: {contract}} = this.props;
    const {deliveryReport = {}, canBeDelivered} = reporting;

    return (
      <div style={{display: 'flex'}}>
        <ul className="unstyled-list" style={{display: 'none'}}>
          <li><BoldText text={`${rentalVehicle.brand} ${rentalVehicle.model}`}/> - {rentalVehicle.licensePlate}</li>
          {rentalVehicle.remark && <li>{rentalVehicle.remark}</li>}
        </ul>
        {canWrite &&
          <div className="mb-1 mt-1">
            <Row type={"flex"} gutter={16}>
              {!deliveryReport.id &&
                <Col>
                  <button onClick={this.unassignMobility} type="primary" className="btn btn-sm btn-primary">
                    {formatMessage({id: 'appointment.detail.mobility.unassign-mobility'})}
                  </button>
                </Col>
              }
              {canBeDelivered &&
                <Col>
                  <button onClick={() => this.onShowReportingModal()} type="primary" className="btn btn-sm btn-primary ml-1">
                    {formatMessage({id: 'appointment.detail.mobility.rental-delivery'})}
                  </button>
                </Col>
              }
            </Row>
            <RentalReportingModal visible={showModal}
                                  onModalClose={this.onHideReportingModal}
                                  rentalVehicle={rentalVehicle} rentalDetails={contract} rentingJourney={intervention} reporting={reporting}
                                  identityDocuments={intervention.identityDocuments}
                                  journeyUuid={journey.uuid} contract={contract}
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchRentalContract: state.fetchRentalContract,
  fetchRentalReporting: state.fetchRentalReporting,
});

const mapDispatchToProps = dispatch => ({
  dispatchUnassignRentalVehicle: (params) => dispatch({type: 'UNASSIGN_RENTAL_VEHICLE.REQUEST', ...params}),
  dispatchFetchJourneyIdentityDocuments: (params) => dispatch({type: 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
  dispatchFetchRentalContract: (rentalDetailsId) => dispatch({type: 'FETCH_RENTAL_CONTRACT.REQUEST', rentalDetailsId}),
  showDeliveryModal: () => dispatch({type: 'SHOW_DELIVERY_MODAL'}),
  hideDeliveryModal: () => dispatch({type: 'HIDE_DELIVERY_MODAL'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(RentalVehicle))
